const CryptoJS = require('crypto-js');  //引用AES源码js
    
const key = CryptoJS.enc.Utf8.parse("1234123432SASCYF");  //十六位十六进制数作为密钥
const iv = CryptoJS.enc.Utf8.parse('SASCYF1234123432');   //十六位十六进制数作为密钥偏移量

//解密方法
function Decrypt(word) {
    let encryptedHexStr = CryptoJS.enc.Hex.parse(word);
    let srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr);
    let decrypt = CryptoJS.AES.decrypt(srcs, key, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
    let decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
    return decryptedStr.toString();
}

//加密方法
function Encrypt(word) {
    let srcs = CryptoJS.enc.Utf8.parse(word);
    let encrypted = CryptoJS.AES.encrypt(srcs, key, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
    return encrypted.ciphertext.toString().toUpperCase();
}




//学习平台加密
// function encryptText() {
//     let timestamp = ((new Date().getTime())/1000).toFixed(0)
//     const keys = CryptoJS.enc.Utf8.parse('researchsysteman'); // Same key as used in Go
//     const iv = CryptoJS.lib.WordArray.random(16); // AES-GCM does not require IV but adding for completeness
//     const encrypted = CryptoJS.AES.encrypt('researchsysteman', keys, { iv: iv });
//     let  encryptedText = encrypted.toString();

//     return  encryptedText
//   }
  function encryptText() { 
    var currentTimestamp = Date.now();
 
// 获取下一秒的时间戳
var nextSecondTimestamp = currentTimestamp + 1000;
     let timestamp =  (nextSecondTimestamp/1000 ).toFixed(0)
  //  let keys =   CryptoJS.enc.Utf8.parse("researchsysteman");
  //   let srcs = CryptoJS.enc.Utf8.parse('researchsysteman');
  //   const ivs = CryptoJS.enc.Utf8.parse('SASCYF1234123432');   //十六位十六进制数作为密钥偏移量

    let str= (timestamp+'researchsysteman')
    console.log(str)
  //   let encrypted = CryptoJS.AES.encrypt(srcs, keys, { iv: ivs, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
  //       console.log(encrypted) CryptoJS.MD5(message).toString();
    let signature =     CryptoJS.SHA256(str).toString()
    // const hash= CryptoJS.createHash('sha256')
    // hash.update(hash)
    // let signature =  hash.digest(timestamp)
    return { signature :signature,timestamp:timestamp}
    // const keys = CryptoJS.enc.Utf8.parse('researchsysteman'); // 16, 24, or 32 bytes key
    // const iv = CryptoJS.lib.WordArray.random(16); // 12 bytes IV for AES-GCM

    // const encrypted = CryptoJS.AES.encrypt('researchsysteman', keys, {
    //   iv: iv,
    //   mode: CryptoJS.mode.GCM,
    //   format: CryptoJS.format.OpenSSL // Use OpenSSL format for compatibility
    // });

    // // Combine IV and ciphertext
    // const combinedData = iv.concat(encrypted.ciphertext);
    // // this.encryptedText = 
    // return  CryptoJS.enc.Base64.stringify(combinedData);
  }
export default {
    Decrypt ,
    Encrypt,
    encryptText
}